import { createSelector } from 'reselect';

import selectState from './selectState';

export default createSelector(
  selectState,
  (state) => state.entities,
);
